import { ROOT_CATALOG_URL } from '@/shared/constants/urlConstants';

import {
  SEARCH_HINT_LABEL_CITY,
  SEARCH_HINT_LABEL_DISTRICT,
  SEARCH_HINT_LABEL_METRO,
  SEARCH_HINT_LABEL_NAME,
  SEARCH_HINT_LABEL_ORGANIZATION,
  SEARCH_HINT_LABEL_SERVICE,
  SEARCH_HINT_LABEL_SPECIALIZATION,
} from '@/shared/constants/searchHintsConstants';

import type { SearchHintValue } from '@/features/SearchHints/model/types/searchHints';

export const searchHintLinkHandlers: Record<
  string,
  (hint: Exclude<SearchHintValue, string>) => string
> = {
  [SEARCH_HINT_LABEL_NAME]: (hint) => {
    if (!('addresses' in hint)) return '';
    const geo = hint.addresses?.[0]?.city.slug ?? '';
    return `${ROOT_CATALOG_URL}geo/${geo}/lawyers/${hint.slug}/`;
  },
  [SEARCH_HINT_LABEL_METRO]: (hint) => {
    if (!('city' in hint)) return '';
    return `${ROOT_CATALOG_URL}geo/${hint.city.slug}?metro=${hint.name}`;
  },
  [SEARCH_HINT_LABEL_DISTRICT]: (hint) => {
    if (!('city' in hint)) return '';
    return `${ROOT_CATALOG_URL}geo/${hint.city.slug}?district=${hint.name}`;
  },
  [SEARCH_HINT_LABEL_SPECIALIZATION]: (hint) => {
    if (!('slug' in hint)) return '';
    return `${ROOT_CATALOG_URL}${hint.slug}/`;
  },
  [SEARCH_HINT_LABEL_SERVICE]: (hint) => {
    if (!('parent' in hint) || !('slug' in hint)) return '';
    return `${ROOT_CATALOG_URL}${hint.parent.slug}/${hint.slug}/`;
  },
  [SEARCH_HINT_LABEL_CITY]: (hint) => {
    if (!('slug' in hint)) return '';
    return `${ROOT_CATALOG_URL}geo/${hint.slug}/`;
  },
  [SEARCH_HINT_LABEL_ORGANIZATION]: (hint) => {
    if (!('lawyer' in hint)) return '';
    const geo = hint.lawyer.addresses?.[0]?.city.slug ?? '';
    return `${ROOT_CATALOG_URL}geo/${geo}/organizations/${hint.lawyer.slug}/`;
  },
};
